export default function ComingSoon() {
  return (
    <main className="relative min-h-screen flex items-center overflow-hidden bg-black">
      <img
        src="/images/landing/hero.webp"
        alt=""
        className="hero-kenburns absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/10" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 fade-up">
        <p className="font-serif text-3xl tracking-tight text-white">CRESTALP</p>
        <div className="mt-8 h-px w-16 bg-sky-500" />
        <p className="mt-8 max-w-2xl text-sm font-extrabold uppercase tracking-[0.2em] text-white md:text-base">
          A Swiss-Based International Visionary Network
        </p>
        <h1 className="mt-5 font-serif text-5xl font-light leading-none tracking-tight text-white sm:text-6xl lg:text-7xl">
          Coming soon
        </h1>
        <p className="mt-6 max-w-xl text-lg font-light leading-relaxed text-white/80 md:text-xl">
          A borderless world, curated in Switzerland.
        </p>
      </div>
    </main>
  );
}
